<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
import {
  CHANGED_RESTAURANT_EVENT,
  EXCEPTION_EVENT
} from "../src/events/eventsSource";

export default {
  inject: ["eventBus"],
  metaInfo : {
    title : 'Hjem',
    titleTemplate: '%s | Fuji Sushi',
    htmlAttrs : {
      lang : 'nb-NO'
    },
    meta : [
      { charset: 'utf-8'},
      { name: 'description', content : 'Vi er en familiebedrift som tilbyr kvalitet-sushi fra den tradisjonelle japanske kjøkken med en touch av familiens hemmelige ingredienser i risen og sausene. Etterhvert utviklet vi også flere menyer med fusjoner fra andre asiatiske kjøkken. Resten er ferske råvarer, og maten lages Ala minute og dette kjenner våre kunder til. Velkommen til oss og opplev sushi professjonelt, godt og rimelig'}
    ]
  },
  // head : {
  //   title : 'Fuji Sushi',
  //   meta : [
  //     {
  //       name : 'Fuji Sushi',
  //       content : 'Vi er en familiebedrift som tilbyr kvalitet-sushi fra den tradisjonelle japanske kjøkken med en touch av familiens hemmelige ingredienser i risen og sausene. Etterhvert utviklet vi også flere menyer med fusjoner fra andre asiatiske kjøkken. Resten er ferske råvarer, og maten lages Ala minute og dette kjenner våre kunder til. Velkommen til oss og opplev sushi professjonelt, godt og rimelig'
  //     }
      
  //   ]

  // },
  components: {},
  data() {
    return {};
  },
  methods: {
    handleChangedRestaurantEvent(e) {
      // console.log(e);
      this.$store.commit("app/CHANGED_RESTAURANT_STATE", e);
      this.$store.commit("cart/CLEAR_CART_STATE", e);
      this.$store.commit("payment/CLEAR_PAYMENT_SESSION_STATE", e);
    },
    //
    // hanlde exceptions
    //
    handleExceptionEvents(e) {
      //this.$router.push('/timeout');
      //console.log(e)
      //console.log(e);
      let status = e.status;
      this.$router.push({ name: "exception", params: { status } });
    },

    handleRemoveExceptionEvents() {},

    handleRemoveChangedRestaurantEvent() {}
  },
  created() {
    console.log('App is created!')
    this.eventBus.$on(
      CHANGED_RESTAURANT_EVENT,
      this.handleChangedRestaurantEvent
    );
    this.eventBus.$on(EXCEPTION_EVENT, this.handleExceptionEvents);
  },
  destroyed() {
    this.eventBus.$off(
      CHANGED_RESTAURANT_EVENT,
      this.handleRemoveChangedRestaurantEvent
    );
    this.eventBus.$off(EXCEPTION_EVENT, this.handleRemoveExceptionEvents);
  }
};
</script>

<style lang="scss">
#app {
  height: 100%;
}
</style>
